<template>
  <div>
    <v-row v-if="showContentTypeSelect" class="my-2" justify="center">
      <v-col md="8">
        <media-type-select v-model="media_type_model" />
      </v-col>
    </v-row>
    <div v-if="media_type_model === 'img'">
      <div v-if="media_content">
        <v-row align="center">
          <v-img :src="media_content" max-height="125" max-width="125" class="rounded-xl" />
          <trash-icon-btn @click="cancelMedia" />
        </v-row>
        <div class="py-2">
          <smart-input
              v-model="additional_text_model"
              :label="$t('pages.createQuestion.mediaSubtitle')"
              hide-details
          />
        </div>

      </div>
      <v-row v-else justify="center">
        <media-gallery @selected="selectedImage"
                       :image-width="imageDimension.width" :image-height="imageDimension.height"
                       :save-original-file-type="imageDimension.saveOriginalFileType"
        />
      </v-row>
    </div>
    <div v-if="media_type_model === 'video'">
      <div v-if="media_content">
        <v-row align="center">
          <div class="mx-2">
            <iframe width="125" height="125" class="rounded-xl" :src="embededYoutubeUrl" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
            ></iframe>
          </div>
          <trash-icon-btn @click="cancelMedia" />
        </v-row>
        <div class="py-2">
          <smart-input
              v-model="additional_text_model"
              :label="$t('pages.createQuestion.mediaSubtitle')"
              hide-details
          />
        </div>
      </div>
      <v-row v-else class="mx-2 align-center">
        <v-text-field
            class="mx-2"
            v-model="youtubeLink"
            label="Youtube link"
            prepend-icon="fab fa-youtube"
            :error-messages="youtubeLinkError"
            @blur="loadYoutube"
        />
        <v-btn :disabled="!youtubeLink" @click="loadYoutube" icon>
          <v-icon color="red-lighten-2" variant="text">fa-solid fa-arrow-left</v-icon>
        </v-btn>
      </v-row>
    </div>
    <v-row v-if="media_type_model==='text'" class="mx-2 align-center">
      <v-text-field
          class="mx-2"
          :label="$t('pages.createQuestion.title')"
          v-model="media_content"
      />
      <trash-icon-btn @click="cancelMedia" />
    </v-row>
  </div>
</template>

<script>
/**
 * Add content before or after question, the content can be an image, Youtube link or simple text.
 */
import MediaTypeSelect from "../questions/MediaTypeSelect";
import MediaGallery from "../../../../../../src/packages/gallery/MediaGallery";
import TrashIconBtn from "dev/components/TrashIconBtn";

export default {
  name: "AddMedia",
  components: { MediaGallery, MediaTypeSelect, TrashIconBtn },
  props: {
    /**
     * use v-model for content, the image link, youtube link or text
     */
    value: { default: null },
    /**
     * The type of the content
     * @values img, text, video
     */
    media_type: { default: null },
    /**
     * additional text when select image or Youtube link
     */
    additional_text: { default: "" },
    /**
     * the required image Dimension, for example: {width: 1720, height: 1080}
     */
    imageDimension: Object,
    label: String

  },
  data() {
    return {
      rules: [
        value => !value || value.size < 500000 || "גודל התמונה צריך להית עד 500k",
      ],
      youtubeLink: "",
      youtubeLinkError: "",
      text_content: "",
    };
  },
  computed: {
    showContentTypeSelect() {
      const type = this.media_type_model;
      if (!type)
        return true;
      if ((type === "img" || type === "video") && !this.media_content)
        return true;
      return false;
    },
    media_type_model: {
      get() {
        return this.media_type;
      },
      set(val) {
        this.$emit("on_media_type", val);
      }
    },
    media_content: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    additional_text_model: {
      get() {
        return this.additional_text;
      },
      set(val) {
        this.$emit("additional_text", val);
      }
    },
    embededYoutubeUrl() {
      const youtubeEmbedTemplate = 'https://www.youtube.com/embed/'
      const urlSplit = this.media_content.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/)
      if (!urlSplit || !urlSplit[2])
        return ''
      const YId = urlSplit[2].split(/[^0-9a-z_/\\-]/i)[0]
      return youtubeEmbedTemplate.concat(YId)
    },
  },

  methods: {
    selectedImage(img) {
      this.media_content = img.imageSrc
    },
    cancelMedia() {
      this.youtubeLink = "";
      this.media_type_model = null
      this.media_content = ""
    },
    loadYoutube() {
      const correctLink = this.checkboxIfIsYoutubeUrl(this.youtubeLink);
      if (!correctLink)
        this.youtubeLinkError = this.$t('pages.createQuestion.invalidYoutubeAddress');
      else {
        this.youtubeLinkError = ""
        this.media_content = this.convertYoutubeLink(this.youtubeLink)
      }
    },
    convertYoutubeLink(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      const id = (match && match[2].length === 11)
          ? match[2]
          : null;
      return "https://www.youtube.com/watch?v=" + id;
    },
    checkboxIfIsYoutubeUrl(youtubeUrlText) {
      const regex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      return regex.test(youtubeUrlText);
    }
  },
};
</script>

<style scoped>
.image-preview {
  max-width: 75px;
}
</style>
